import React, { useEffect, useReducer, useState } from "react"
import AddNewModifier from "./AddNewModifier"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import Table from "../../Shared/Table"
import SearchHeader from "../../Shared/SearchHeader"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import handleCopyText from "../../../shared/CopyData"
import MasterList from "../../Shared/MasterList"
import isNull from "../../../../utils/NullChecking"
import { connect } from "react-redux"
import usePagination from "../../../../customhooks/usePagination"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const Modifier = (props) => {
    const API_URL = enumUtil.controller.General
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Modifiers')?.IsAdd

    const [isOpenModifier, setisOpenModifier] = useState(false)
    const [ModifierData, setModifierData] = useState([]);
    const [ModifierCode, setModifierCode] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [isOpenMasterList, setisOpenMasterList] = useState(false)
    const [totalCounts, setTotalCounts] = useState(false)
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false,
        masterListButton: true,  // set true if want to display cards as well
    }

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////

    const LoadData = (param, types) => {
        setIsLoading(true)
        // setModifierData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Modifier,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setModifierData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setisOpenModifier(true)
                }
            }
        }).catch((error) => {
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (ModifierData?.length == 0 && isNull(searchParamType)) {
                    setisOpenModifier(true)
                }
            }
        })
    }

    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }
    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])
    const AddModifier = (ID) => {
        setisOpenModifier(true)
        setModifierCode(ID)
    }
    const CloseModifier = () => {
        setisOpenModifier(false)
    }
    const DeleteModifier = () => {
        setisOpenModifier(false)
        setIsClose((Math.random()));
    }

    const handleRowSelection = (row) => {
        // console.log(row);
    }
    const CloseMasterList = (ID) => {
        setisOpenMasterList(false)
        // setPOSCode(ID) 
    }
    let PopupScreenMasterList = "";
    if (isOpenMasterList) {
        PopupScreenMasterList = <MasterList isOpen={isOpenMasterList} onClose={CloseMasterList} LoadData={LoadData} GridTableName={'MasterListModifier'} SaveTableName={'MASTERLISTMODIFIER'} type={type} Name={"Modifier"}  IsEditAllowed={IsEditAllowed}/>
    }
    const handleMasterList = () => {
        setisOpenMasterList(true)
    }
    const [copiedText, setCopiedText] = useState({});


    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }


    const columns = [

        {
            key: 'ModifierCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Modifier Code'} sortIcon={true} type={'number'} colKey={'ModifierCode'} data={ModifierData} setData={setModifierData} />),
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddModifier(row.ModifierCodeID)}>{row.ModifierCode} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ModifierCodeID, row.ModifierCode)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.ModifierCodeID}-${row.ModifierCode}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={ModifierData} setData={setModifierData} />),
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Description}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ModifierCodeID, row.Description)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.ModifierCodeID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'FullDescription',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Full Description'} sortIcon={true} type={'string'} colKey={'FullDescription'} data={ModifierData} setData={setModifierData} />),
            flex: 1,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.FullDescription}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ModifierCodeID, row.FullDescription)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.ModifierCodeID}-${row.FullDescription}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'UpdatedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={ModifierData} setData={setModifierData} />),
            resizable: true,
        },
        {
            key: 'UpdatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated Date'} sortIcon={true} type={'string'} colKey={'UpdatedDate'} data={ModifierData} setData={setModifierData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.UpdatedDate}
                        </div>
                    </>
                );
            }
        },
    ]
    let PopupScreen = "";
    if (isOpenModifier) {
        PopupScreen = <AddNewModifier isOpenModifier={isOpenModifier} onClose={CloseModifier} onDeleteModifier={DeleteModifier} ModifierCode={ModifierCode} type={type} />
    }



    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const handleClearSearch = () => {
        setSearchParam('')
    }
    const ModifierBody = () => {
        return (
            <>
                <div className='container-fluid action-row br-clr'>
                    <div className="row justify-content-between">
                        <div className="col-4 form-rounded">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by Modifier Code or Description…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter}
                                        value={searchParam}
                                    />
                                    {searchParam?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddModifier}
                                Excel={handleExcel}
                                PDF={handlePdf}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                masterListButton={handleMasterList}
                                show={show}
                                searchButton={searchButton}
                                Key={635}
                                Name={'Modifiers'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>
                {show === false ?
                    <Table
                        columns={columns}
                        rows={ModifierData}
                        height='500px'
                        rowClass={rowClass}
                        // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                        dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_code_table'
                        rowHeight={25}
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        handlePageClick={handlePageClick}
                        PreviousPage={PreviousPage}
                        handleFingByCreteria={handleFingByCreteria}
                        NextPage={NextPage}
                        Key={635}
                        Name={'POS'}
                        isLoading={isLoading}
                        TableName={'Modifier'}
                        handleSelectData={handleSelectData}
                        LoadData={() => LoadData(searchParam)}
                         ClearSearch={handleClearSearch}
                    /> : null
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(ModifierData?.length == 0 && isNull(searchParamType)){
    //             setisOpenModifier(true)
    //         }
    //     }
    // },[ModifierData, searchParamType])
    return (
        <React.Fragment>
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {ModifierData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {isOpenModifier ? <>{PopupScreen}</> : isOpenMasterList ? <>{PopupScreenMasterList}</> : <>{ModifierBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {PopupScreenMasterList}
                    {ModifierBody()}
                </>
            }


        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(Modifier)